import DefaultGrid from '@components/ui/ProductGrid/ProductGrid'
import { ProductGridTileFragment } from '@lib/graphql/graphql'
import { isAvailableForPurchase } from '@lib/is-available-for-purchase'
import { FC } from 'react'
import { UrlFilter } from '../Filter/filtering'
import { UrlSorting } from '../Sorting/sorting'

type ProductCollectionProps = {
  filter?: UrlFilter[]
  sortBy?: UrlSorting
  soldOnline?: boolean
  products?: ProductGridTileFragment[]
  recommendations?: ProductGridTileFragment[]
  lcp?: boolean
}
const ProductCollection: FC<ProductCollectionProps> = ({
  filter,
  sortBy,
  soldOnline,
  products,
  recommendations,
  lcp,
}) => {
  const clientSideSort = (
    a: ProductGridTileFragment,
    b: ProductGridTileFragment,
    sortBy?: UrlSorting,
  ) => {
    if (!sortBy) return 0

    const getPrice = (product: ProductGridTileFragment) => {
      return (
        // product.heroVariant.discountedPrice?.value.centAmount ??
        product.heroVariant?.price?.value.centAmount
      )
    }

    switch (true) {
      case sortBy.field == 'name' && sortBy.direction === 'ASC':
        return a.name > b.name ? 1 : -1
      case sortBy.field == 'name' && sortBy.direction === 'DESC':
        return a.name > b.name ? -1 : 1
      case sortBy.field == 'price' && sortBy.direction == 'ASC':
        return getPrice(a) == getPrice(b)
          ? 0
          : getPrice(a) < getPrice(b)
            ? -1
            : 1
      case sortBy.field == 'price' && sortBy.direction == 'DESC':
        return getPrice(a) == getPrice(b)
          ? 0
          : getPrice(a) < getPrice(b)
            ? 1
            : -1
      default:
        break
    }
    return 0
  }

  const productMix = recommendations ? recommendations : products

  return (
    // flex flex-wrap
    <DefaultGrid
      lcp={lcp}
      products={productMix
        ?.filter((product) => {
          if (soldOnline) {
            return isAvailableForPurchase(product.heroVariant?.availability)
          } else {
            return true
          }
        })
        ?.filter((product) => {
          if (!filter) return true

          return filter.every((f) => {
            if (
              f.slug === 'categories' ||
              f.slug === 'designers' ||
              f.slug === 'collections' ||
              f.slug === 'types'
            ) {
              return product.tags.find((tag) => f.values.includes(tag))
            }
            return false
          })
        })
        .sort((a, b) => clientSideSort(a, b, sortBy))}
    />
  )
}

export default ProductCollection
